import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.7,
  delay,
  ease: 'easeOut'
}} className={className} data-id="element-262" data-mp="3vm378wh86opo">
    {children}
  </motion.div>;
export const Button = ({
  children,
  onClick,
  href,
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-body font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 cursor-pointer';
  const variants = {
    primary: 'bg-gradient-to-r from-pink-primary to-celeste-primary text-white',
    outline: 'border-2 border-pink-primary text-pink-deep hover:bg-pink-light'
  };
  if (href) {
    return <a href={href} onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className} no-underline`} style={{
      fontSize: "16px"
    }} data-id="element-263" data-mp="3mky1tf6yad5t">
        {children}
      </a>;
  }
  return <button onClick={() => {
    if (onClick) onClick();
    window.open('https://pagos.auradigital.fun/cart/48069934907492:1', '_blank', 'noopener,noreferrer');
  }} className={`${baseStyle} ${variants[variant]} ${className}`} data-id="element-264" data-mp="3rihfacvtqlwp">
      {children}
    </button>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-12 md:py-20 px-4 sm:px-6 lg:px-8 overflow-hidden ${className}`} data-id="element-265" data-mp="e3l6le6m2yp3">
    <div className="max-w-5xl mx-auto" data-id="element-266" data-mp="j24rdb9gy4fv">{children}</div>
  </section>;
export const FloralSeparator = () => <div className="flex items-center justify-center py-4 opacity-60" data-id="element-267" data-mp="2fz3t3bqj90wp">
    <div className="h-px w-16 bg-pink-border" data-id="element-268" data-mp="2kwdqpeo2sivm"></div>
    <span className="mx-4 text-pink-primary text-xl" data-id="element-269" data-mp="2cummib4rju5v">🌸</span>
    <div className="h-px w-16 bg-pink-border" data-id="element-270" data-mp="2cx8v8e3e4fpo"></div>
  </div>;